import { StaticImageData } from 'next/image';
import { BREAKPOINT_INCLUSION_FLAGS } from 'src/components/Skeleton/SkeletonCard';
import { ZHLPersonalizedNextStepState } from 'src/services/graphql/generated/graphql';
import { LookupValues } from 'src/utils/types';

export const IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS = {
    DESKTOP: `701px${BREAKPOINT_INCLUSION_FLAGS.GTE}`,
    TABLET: '700px',
    PHABLET: '600px',
    HORIZONTAL_MOBILE: '530px',
    LARGE_MOBILE_DEVICE: '480px',
    MEDIUM_MOBILE_DEVICE: '430px',
    SMALL_MOBILE_DEVICE: '400px',
    XTRA_SMALL_MOBILE_DEVICE: '340px',
} as const;
export type DesignSpecifiedBreakpoint = LookupValues<typeof IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS>;
export const DESIGN_BREAKPOINT_TO_IMAGE_HEIGHT: Record<DesignSpecifiedBreakpoint, string> = {
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.DESKTOP]: '420px',
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.TABLET]: '380px',
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.PHABLET]: '330px',
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.HORIZONTAL_MOBILE]: '300px',
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.LARGE_MOBILE_DEVICE]: '240px',
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.MEDIUM_MOBILE_DEVICE]: '220px',
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.SMALL_MOBILE_DEVICE]: '180px',
    [IMAGE_DIMENSIONS_DESIGN_SPECIFIED_BREAKPOINTS.XTRA_SMALL_MOBILE_DEVICE]: '150px',
} as const;

const setImage: (src: string) => StaticImageData = src => ({
    src,
    height: 556,
    width: 1080,
});

export type ApplicationLifecycleStatus =
    | ZHLPersonalizedNextStepState.NEW_APPLICATION
    | ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS
    | ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL
    | ZHLPersonalizedNextStepState.OUTSTANDING_TASKS
    | ZHLPersonalizedNextStepState.WAITING_TO_CLOSE;
export const APPLICATION_LIFECYCLE_STATUS_TO_IMAGES: Record<ApplicationLifecycleStatus, StaticImageData> = {
    [ZHLPersonalizedNextStepState.NEW_APPLICATION]: setImage(
        'https://delivery.digitallibrary.zillowgroup.com/public/finance-home-light_CMS_Medium_Large.webp'
    ),
    [ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS]: setImage(
        'https://delivery.digitallibrary.zillowgroup.com/public/applying-home_light_svg_LCM_Card_Side_by_Side_Desktop_504x464.webp'
    ),
    [ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL]: setImage(
        'https://delivery.digitallibrary.zillowgroup.com/public/sell-home-yourself-light_svg_LCM_Card_Side_by_Side_Desktop_504x464.webp'
    ),
    [ZHLPersonalizedNextStepState.OUTSTANDING_TASKS]: setImage(
        'https://delivery.digitallibrary.zillowgroup.com/public/applying-home_light_svg_LCM_Card_Side_by_Side_Desktop_504x464.webp'
    ),
    [ZHLPersonalizedNextStepState.WAITING_TO_CLOSE]: setImage(
        'https://delivery.digitallibrary.zillowgroup.com/public/buy-home_light_svg_LCM_Card_Side_by_Side_Desktop_504x464.jpg'
    ),
};
